import { faCheck, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import i18n, { Ti18nKeys } from "../../../constants/i18n";
import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3Text from "../../../core/et3-text";
import {
  SURFACE_BORDER,
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../../../core/et3-theme/surface-constants";
import {
  APPROVAL_SOFT_APPROVED,
  EMPTY_STATE_BODY_FONT_SIZE,
  EMPTY_STATE_GAP,
  EMPTY_STATE_GLYPH_BOX,
  EMPTY_STATE_GLYPH_RADIUS_CSS,
  EMPTY_STATE_GLYPH_SIZE,
  EMPTY_STATE_PADDING,
  EMPTY_STATE_TITLE_FONT_SIZE
} from "./approval-data-constants";

const ApprovalEmptyState = withLiteObserverAndTheme<{
  titleKey: Ti18nKeys;
  bodyKey: Ti18nKeys;
  isNotLoaded: boolean;
}>((props) => {
  const { titleKey, bodyKey, isNotLoaded, theme } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        border: SURFACE_BORDER,
        borderRadius: SURFACE_RADIUS_CSS,
        boxShadow: SURFACE_SHADOW,
        padding: `${EMPTY_STATE_PADDING * unitY}px ${
          EMPTY_STATE_PADDING * unitX
        }px`,
        gap: EMPTY_STATE_GAP * unitY
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={EMPTY_STATE_GLYPH_BOX}
        height={EMPTY_STATE_GLYPH_BOX}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={APPROVAL_SOFT_APPROVED}
        style={{ borderRadius: EMPTY_STATE_GLYPH_RADIUS_CSS, flexShrink: 0 }}
        onClick={() => {}}
      >
        <FontAwesomeIcon
          icon={isNotLoaded ? faDownload : faCheck}
          color={colors.all.green}
          style={{
            width: EMPTY_STATE_GLYPH_SIZE * unitX,
            height: EMPTY_STATE_GLYPH_SIZE * unitY
          }}
        />
      </ET3Div>
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={EMPTY_STATE_TITLE_FONT_SIZE}
        text={i18n.get(titleKey)}
        isSpan={true}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0, textAlign: "center" }}
      />
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={EMPTY_STATE_BODY_FONT_SIZE}
        text={i18n.get(bodyKey)}
        isSpan={false}
        color={colors.all.davysGrey}
        style={{ margin: 0, textAlign: "center", maxWidth: 520 * unitX }}
      />
    </ET3Div>
  );
});
export default ApprovalEmptyState;
